module.exports = __webpack_public_path__ + "static/media/0B.89324fe5.png";